var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolbsIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_5_2",
    "data-name": "Component 5 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.187,
    height: 13.415,
    viewBox: "0 0 16.187 13.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M8.119.907,6.546,2.48.551,8.475a.46.46,0,0,0-.132.281L0,12.906a.463.463,0,0,0,.46.509.345.345,0,0,0,.046,0L4.659,13a.461.461,0,0,0,.281-.133l5.995-5.994L12.507,5.3A3.1,3.1,0,0,0,8.119.907M4.4,12.093l-3.423.343.343-3.423L6.873,3.461,9.953,6.541ZM11.853,1.561a2.18,2.18,0,0,1,0,3.081L10.607,5.887,7.527,2.807,8.772,1.561a2.181,2.181,0,0,1,3.081,0",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M22.692,24.038H14.966a.462.462,0,0,0,0,.925h7.726a.462.462,0,0,0,0-.925",
    transform: "translate(-6.968 -11.548)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolbsIcon9);
export default __webpack_public_path__ + "static/media/evolbs_icon9.038ea598.svg";
export { ForwardRef as ReactComponent };